/**
 * frontend/src/pages/valuation/_FinancialsSources.tsx
 *
 * VAL-PATH-TYPED-FINANCIALS (P2c) — inside a year's tie-out card: the files the
 * year was read from, and each figure the owner typed with the file's own
 * figure beside it. Both are shown as the server sends them; nothing is chosen here.
 */
import type { TieoutSources } from '@/api/valuationFinancials'
import { CLIENT_TEXT } from './_typedFinancialsText'

const fmt = (n: number | null | undefined) =>
  typeof n === 'number' ? n.toLocaleString('en-US', { maximumFractionDigits: 2 }) : '—'

export function FinancialsSources({ year, sources }: { year: number; sources: TieoutSources }) {
  const headingId = `sources-${year}`
  return (
    <section aria-labelledby={headingId} className="space-y-1 text-sm text-pal-ink-body">
      <h3 id={headingId} className="font-medium text-pal-ink">{CLIENT_TEXT.SOURCES_HEADING}</h3>
      {sources.documents.length > 0 ? (
        <ul>{sources.documents.map(f => <li key={f}>{f}</li>)}</ul>
      ) : (
        <p>{CLIENT_TEXT.SOURCES_NO_FILES}</p>
      )}
      {sources.owner_entered.length > 0 && (
        <ul>
          {sources.owner_entered.map(o => (
            <li key={o.field} data-testid={`typed-${year}-${o.field}`}>
              {`${o.label}: ${CLIENT_TEXT.SOURCES_TYPED_VALUE(fmt(o.value))}`}
              {o.filename && ` · ${CLIENT_TEXT.SOURCES_FILE_VALUE(fmt(o.document_value), o.filename)}`}
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
